/**
 * The DidMountEvent event name.
 */
export const DidMountEvent = 'onDidMount'

/**
 * The WillUnmountEvent event name.
 */
export const WillUnmountEvent = 'onWillUnmount'
